import { usePortraits } from '../editor/portraits';
import type { MusterView, SessionSnapshot } from '../game/session';
import { sideName } from '../game/sideName';

export function MusterOverlay({
  snapshot,
  muster,
  onRespond,
  onMenu,
  onRules,
}: {
  snapshot: SessionSnapshot;
  muster: MusterView;
  onRespond: (pieceId: number | null) => void;
  onMenu: () => void;
  onRules: () => void;
}) {
  const portraits = usePortraits(snapshot.ctx.roster);
  return (
    <div className="card-battle" role="dialog" aria-label="Muster">
      <section className="muster-panel">
        <div className="card-battle-menu row">
          <button onClick={onMenu} data-testid="muster-menu">
            Menu
          </button>
          <button onClick={onRules} data-testid="muster-rules">
            Rules
          </button>
        </div>
        <h1>{sideName(snapshot, muster.faction)}: join the muster?</h1>
        <p>
          Joining spends this side’s next normal board action. Choose one reachable main fighter or
          pass.
        </p>
        <div className="support-cards">
          {muster.pieces.map((piece) => (
            <button
              className="battle-card muster-card"
              key={piece.id}
              onClick={() => onRespond(piece.id)}
            >
              <span className="card-portrait small">
                {portraits[piece.character] ? (
                  <img src={portraits[piece.character]} alt={piece.name} />
                ) : (
                  piece.name.slice(0, 1)
                )}
              </span>
              <strong>{piece.name}</strong>
            </button>
          ))}
          <button className="no-support" onClick={() => onRespond(null)}>
            Pass
          </button>
        </div>
      </section>
    </div>
  );
}
